export const handleSuffle=(array=>{
   

    return array.sort(()=>Math.random()-0.5)
})